import { AppLayout } from "@amzn/awsui-components-react";
import React, { useEffect, useState } from "react";
import IPLClaimIntakeApp from "src/app/IPL/IPLClaimIntakeApp";
import { PAGE_TITLES } from "src/app/constants";
import SideMenu from "src/components/sideMenu/SideMenu";

function IPLClaimIntakePage() {
  const [navigationOpen, setNavigationOpen] = useState(true);

  useEffect(() => {
    document.title = PAGE_TITLES.IPL_CLAIM_INTAKE_FORM;
  }, []);

  return (
    <AppLayout
      content={<IPLClaimIntakeApp></IPLClaimIntakeApp>}
      navigation={<SideMenu />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      ariaLabels={{
        navigationClose: "Close side menu",
        navigationToggle: "Open Side menu",
      }}
      toolsHide={true}
      contentType="wizard"
      footerSelector="#app-footer"
      headerSelector="#app-header"
    />
  );
}

export default IPLClaimIntakePage;